<div class="flex items-center justify-between py-6">
  <div class="flex items-center justify-center gap-3">
    <img ngSrc="logo-sparkle.svg" width="32" height="32" alt="Appsense AI Sparkle Logo" />
    <h1
      class="brand-gradient-text font-brand text-[20px] font-bold tracking-tight uppercase opacity-80"
    >
      APPSENSE AI
    </h1>
  </div>

  <button
    class="border border-outline-variant rounded-full p-2.5 hover:bg-surface-container cursor-pointer transition-colors"
    (click)="startNewChatSession.emit()"
  >
    <img
      ngSrc="plus-document.svg"
      width="20"
      height="20"
      alt="Appsense AI Sparkle Logo"
      class="cursor-pointer"
    />
  </button>
</div>
